import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { CursorPagedMarketProducts } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type MarketProductsResponse = CursorPagedMarketProducts;

export type MarketProductsParams = {
  vendorId?: number;
  categoryIds?: number[];
  displayCategoryIds?: Array<number | string>;
  productType?: string;
  deliveryType?: string;
  salesTarget?: string;
  salesTargets?: string[];
  sortType?: string;
  size?: number;
  searchAfter?: string[];
  [key: string]: unknown;
};

export interface MarketProductsDataSource {
  // Query
  getMarketProducts(
    params: MarketProductsParams,
  ): Promise<MarketProductsResponse>;
  getMarketProductsCount(params: MarketProductsParams): Promise<number>;
}

export class MarketProductsDataSourceImpl implements MarketProductsDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getMarketProducts(params: MarketProductsParams) {
    return this.client.request<MarketProductsResponse>({
      url: '/api/market-place/v3/products',
      method: 'get',
      params: { ...params },
    });
  }

  async getMarketProductsCount(params: MarketProductsParams) {
    return this.client.request<number>({
      url: '/api/market-place/v3/products/count',
      method: 'get',
      params: { ...params },
    });
  }
}

export const marketProductsDataSource = new MarketProductsDataSourceImpl();
